<template>
  <component
    :is="type"
    class="printing-field-root"
  >
    <div class="printing-field-label">
      <b>{{ value ? `${label}/ ` : label }}</b>
    </div>
    <div class="printing-field-value">
      {{ value }}
    </div>
  </component>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'h4',
    },
  },
};
</script>

<style lang="scss" scoped>
.printing-field-root {
  display: flex;

  .printing-field-value {
    flex: 1;
  }

  .printing-field-label {
    margin-left: 5px;
  }
}
</style>
